import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { ThemeScroll } from '../FeatureAppTypes';

/**
 * Component to add horizontal spacing according to the new spec, until it is implemented in Audi UI
 * https://react.ui.audi/?path=/docs/brand-identity-spacing--page
 */
const StyledContainer = styled.div<{ breakpoints: ThemeScroll['breakpoints'] }>`
  margin-right: var(--page-margin);
  margin-left: var(--page-margin);
`;
export interface ContainerProps extends PropsWithChildren {
  theme: ThemeScroll;
}

export const ContentContainer: React.FC<ContainerProps> = ({ children, theme }) => {
  const { breakpoints } = theme;

  return <StyledContainer breakpoints={breakpoints}>{children}</StyledContainer>;
};
